export default [
    {
        path: '/popin/next/:index',
        name: 'popin.next'
    },
]